module.exports = __webpack_public_path__ + "img/icon_lesson-amount.67844c0e.png";